import axios from "axios";

const API_URL = '/api/email';

export const sendEmailWithFile = async (userId, fileId, recipientEmail, message) => {
    try {
        const response = await axios.post(`${API_URL}/send-email`, {
            userId,
            fileId,
            recipientEmail,
            message
        });
        return response.data;
    } catch (error) {
        console.error('Error sending email with file:', error);
        throw error;
    }
}